// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2V3sR","image":"Header_image__afD57","name":"Header_name__3XjDd","info":"Header_info__KOY0E","infoRow":"Header_infoRow__2hEdD"};